'use client';

const AboutMission = () => {
    return (
        <>
            <section className="relative flex flex-col  overflow-hidden">
                {/* Full Width - Yellow Background with Content */}
                <div className="w-full bg-white flex items-center justify-center p-8 md:p-12 lg:p-16 text-center md:text-left">

                    <div className="max-w-9xl mx-auto text-gray-900">
                        <p className="text-3xl sm:text-5xl lg:text-6xl text-start font-medium leading-tight md:text-2xl text-gray-700 mb-4 ">
                            <span className="text-yellow-600">Our Mission is simple</span>
                        </p>
                        <h2 className="text-3xl sm:text-5xl lg:text-6xl font-medium leading-tight mb-6 text-start">
                            <br className="select-none" /> We provide reliable, top-quality industrial supplies and great service.
                        </h2>

                    </div>
                </div>
            </section>
        </>

    )

}

export default AboutMission;